export default class SalesAnalysisColumnDefinitionFactory {
  static create (columnDef) {
    if (columnDef.formatType) {
      return { ...columnDef, cellRendererFramework: 'AgGridCellFormatter' }
    } else if (columnDef.children) {
      return { ...columnDef, children: columnDef.children.map((child) => SalesAnalysisColumnDefinitionFactory.create(child)) }
    } else {
      return columnDef
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sales_analysis/models/SalesAnalysisColumnDefinitionFactory.js